export default __webpack_public_path__ + "static/media/mobile.fbd8a0b0.jpg";